/*
 *
 * ConfirmReverseTransactionModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 30-Jun-2025
*/

import ConfirmReverseTransactionModal from './ConfirmReverseTransactionModalContainer'

export default ConfirmReverseTransactionModal
